module.exports = __webpack_public_path__ + "static/08-68838e7c9774ac69b0be37eb03837983.jpg";